var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Interactivity',{attrs:{"mode":"Live","votingFirst":false,"Ismobile":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }